import { z } from "zod";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import {
  ACCEPTED_FILE_TYPES,
  MAX_UPLOAD_MB,
  MAX_UPLOAD_SIZE,
} from "../../../utils/form/variables";

export const dateSchema = z.instanceof(dayjs as unknown as typeof Dayjs, {
  message: "SÃ©lectionnez une date",
});

// export const dateSchemaBeforeToday = z
//   .instanceof(dayjs as unknown as typeof Dayjs, {
//     message: "SÃ©lectionnez une date",
//   })
//   .refine((date) => date.isBefore(), {
//     message: "La date doit Ãªtre antÃ©rieure Ã  aujourd'hui",
//   });

export const attachmentSchema = z
  .array(z.custom<File>())
  .refine(
    (files) => {
      // Check if all items in the array are instances of the File object
      return files.every((file) => file instanceof File);
    },
    {
      // If the refinement fails, throw an error with this message
      message: 'Un format "File" est attendu',
    },
  )
  .refine(
    (files) => files.every((file) => file.size <= MAX_UPLOAD_SIZE),
    `Chaque fichier doit Ãªtre infÃ©rieur Ã  ${MAX_UPLOAD_MB}MB`,
  )
  .refine(
    (files) => files.every((file) => ACCEPTED_FILE_TYPES.includes(file.type)),
    "Seuls les fichiers PNG, JPEG et PDF sont acceptÃ©s",
  )
  .optional();
